import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ReasonsActions } from "store/ducks/reasons";

import { Page, Panel, Loading, Breadcrumbs } from "components";

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Documentos", to: "/documents" },
      { name: "Lista de Razões", to: "/reasons" },
    ],
  };

  componentDidMount() {
    const { getReasonsRequest } = this.props;

    getReasonsRequest();
  }

  render() {
    const { breadcrumbs } = this.state;
    const { reasons } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Razões</Page.Title>

        <Panel className="panel-list">
          {!reasons.data.length && reasons.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {reasons.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>título</th>
                    <th>descrição</th>
                    <th>alias</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!reasons.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {reasons.data.map((reason) => (
                    <tr key={String(reason.id)}>
                      <td>{reason.title}</td>
                      <td>{reason.description}</td>
                      <td>{reason.alias}</td>
                      <td className="text-right">
                        {/* {Access.hasPermissions('edit-reasons') && ( */}
                        <Link
                          to={`/reasons/${reason.id}/edit`}
                          className="button-icon"
                        >
                          <span className="glyph glyph-eye" />
                        </Link>
                        {/* )} */}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              {/* {Access.hasPermissions('edit-reasons') && ( */}
              <Link to="/reasons/create" className="button-add margin-top-20">
                Adicionar razão
              </Link>
              {/* )} */}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  reasons: state.reasons,
});

const mapActions = (dispatch) => bindActionCreators(ReasonsActions, dispatch);

export default connect(mapState, mapActions)(List);
